import { useRef } from 'react'
import { Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material'
import Beacon4FilterBar   from './components/filters/Beacon4FilterBar'
import Beacon4LegendPanel from './components/filters/Beacon4LegendPanel'
import Beacon4BlendedView  from './components/Beacon4BlendedView'
import Beacon4ExportButton from './components/Beacon4ExportButton'

const theme = createTheme({
  typography: { fontFamily: "'IBM Plex Sans', sans-serif" },
  palette:    { primary: { main: '#1565c0' }, background: { default: '#f0f2f5' } },
})

export default function App() {
  const chartAreaRef = useRef(null)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
        <Box sx={{ flexShrink: 0 }}>
          <Beacon4FilterBar
            exportButton={<Beacon4ExportButton containerRef={chartAreaRef} />}
          />
        </Box>
        <Box sx={{ display: 'flex', overflow: 'hidden', height: 'calc(100vh - 130px)' }}>
          <Box ref={chartAreaRef} sx={{ flex: 1, minWidth: 0, p: '12px 16px', overflowY: 'auto' }}>
            <Beacon4BlendedView />
          </Box>
          <Beacon4LegendPanel />
        </Box>
      </Box>
    </ThemeProvider>
  )
}